import {
  Flex, FlexColumn, ThemeType, InputRow,
} from '@equifinance/shared';
import styled, { css } from 'styled-components';

export const CreditDetailsContainer = styled(FlexColumn)` ${({ theme }) => `
  padding-left:${theme.padding[5]};
  padding-right:${theme.padding[5]};
`}`;

export const CreditDetailsBottomContainer = styled(Flex)` ${({ theme }) => `
  padding: ${theme.padding[5]};
  background:${theme.colours.primary[8]};
  flex-wrap: wrap;
  gap:${theme.padding[4]};
`}`;

export const EquifaxAccordionHeaderShadow = styled.div` ${({ theme }) => `
  height: ${theme.collapseHeaderShadowHeight};
  background: linear-gradient(180deg, ${theme.colours.primary[7]} 0%, ${theme.colours.primary[8]} 100%);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`}`;

export const CreditDetailsEquifax = styled(FlexColumn)` ${({ theme }) => `
  padding: ${theme.padding[5]};
  background:  ${theme.colours.primary[8]};
  gap: ${theme.padding[6]};
  border-radius: 0px 0px ${theme.padding[2]} ${theme.padding[2]};

  ${CreditDetailsBottomContainer} {
    padding: 0;
  }
`}`;

export const InsolvencyEquifax = styled(CreditDetailsEquifax)` ${({ theme }) => `
  padding-bottom: ${theme.padding[7]};
  ${CreditDetailsBottomContainer} {
    padding-bottom: ${theme.padding[8]};
  }
`}`;

export const CreditDetailsPaymentHistoryContainer = styled(FlexColumn)` ${({ theme }) => `
  gap: ${theme.padding[6]};
  width: 100%;
`}`;

export const CreditDetailsRow = styled(InputRow)<{alignItem?: string}>` ${({ theme, alignItem = 'flex-start' }) => `
  align-items: ${alignItem};
  width: calc(100% - ${theme.padding[8]} * 4);
  margin: 0 auto;
  padding-top: ${theme.padding[5]};
  padding-bottom: ${theme.padding[7]};
`}`;

export const CreditDetailsUserOutputContainerText = styled.p` ${({ theme }) => ` 
  color:${theme.colours.neutral[2]};
  font-size:${theme.fontSize[1]};
  line-height: ${theme.fontSize[3]};
`}`;

export const CreditDetailsUserOutputContainerTextTitle = styled(CreditDetailsUserOutputContainerText)` ${({ theme }) => ` 
  color:${theme.colours.primary[1]};
  font-weight:${theme.fontWeight.bold};
`}`;

export const CreditDetailsUserOutputChild = styled(Flex)` ${({ theme }) => `
  justify-content:space-between;
  width:50%;
  padding: ${theme.padding[2]} ${theme.padding[6]};
`}`;

export const CreditDetailsUserOutputChildTitle = styled(CreditDetailsUserOutputChild)`
  padding-top:0;
  padding-bottom:0;
`;

export const CreditHistoryContainer = styled(Flex)` ${({ theme }) => `
  width:100%;
  gap: ${theme.borderWidth[1]};
`}`;

export const CreditHistoryBoxContainer = styled(FlexColumn)` ${({ theme }) => `
  width:calc(100% /24);
  font-size: ${theme.fontSize[1]};
  font-weight: ${theme.fontWeight.bold};
  gap: ${theme.borderWidth[1]};
`}`;

const getStatusBgColour = (status: string, theme: ThemeType) => {
  const defaultColour = theme.colours.neutral[7];

  switch (status) {
    case '0':
    case 'S':
      return theme.colours.success[1];
    case '1':
    case '2':
      return theme.colours.highlight[1];
    case '3':
    case '4':
    case '5':
    case '6':
    case 'B':
    case 'D':
      return theme.colours.danger[1];
    case 'A':
    case 'R':
    case 'V':
      return theme.colours.neutral[10];
    default:
      break;
  }

  return defaultColour;
};

const getStatusColour = (status: string, theme: ThemeType) => {
  const defaultColour = theme.colours.neutral[1];

  switch (status) {
    case '0':
    case 'S':
    case '3':
    case '4':
    case '5':
    case '6':
    case 'B':
    case 'D':
      return theme.colours.neutral[10];
    default:
      break;
  }

  return defaultColour;
};

export const CreditHistoryBox = styled(Flex)<{status: string}>` ${({ theme, status }) => `
  background:100%;
  background: ${getStatusBgColour(status, theme)};
  justify-content:center;
  align-items:center;
  padding: ${theme.padding[1]} ${theme.padding[3]};
  color: ${getStatusColour(status, theme)};
  height: ${theme.padding[4]};
`}`;

export const CreditHistoryBoxAge = styled(Flex)` ${({ theme }) => `
  justify-content:center;
  align-items:center;
  background:${theme.colours.neutral[10]};
  padding: ${theme.padding[1]} ${theme.padding[3]};
  height: ${theme.padding[4]};
  color: ${theme.colours.neutral[2]};
`}`;

export const Title = styled.h1` ${({ theme }) => `
  font-size: ${theme.fontSize[2]};
  color: ${theme.colours.neutral[2]};
  font-weight: ${theme.fontWeight.bold};
  margin: 0;
`}`;

export const DetailsTitle = styled.div` ${({ theme }) => `
  font-size: ${theme.fontSize[1]};
  background:${theme.colours.primary[11]};
  color:${theme.colours.primary[1]};
  font-weight:${theme.fontWeight.bold};
  padding:${theme.padding[1]};
  padding-left:${theme.padding[7]};
  border-radius:${theme.borderRadius[1]};
  letter-spacing: ${theme.letterSpacing[1]};
`}`;

export const CreditDetailsOutputContainerLabel = styled.p` ${({ theme }) => ` 
  color:${theme.colours.neutral[2]};
  font-size: ${theme.fontSize[2]};
  line-height: ${theme.fontSize[7]};
`}`;

export const CreditDetailsOutputContainerValue = styled(CreditDetailsOutputContainerLabel)` 
  text-align: right;
`;

export const CreditDetailsOutputContainer = styled(Flex)` ${({ theme }) => ` 
  align-items:center;
  background:${theme.colours.neutral[10]};
  border-radius:${theme.borderRadius[1]};
  justify-content:space-between;
  box-sizing: border-box;
  width: calc(50% - ${theme.padding[2]});
  padding: ${theme.padding[1]} ${theme.padding[6]};
`}`;

export const CreditDetailsUserOutputContainer = styled(CreditDetailsOutputContainer)` ${({ theme }) => `
  background:${theme.colours.primary[7]};
  width:100%;
  gap: ${theme.padding[4]};
  justify-content:start;
  padding: 0;
`}`;

export const CreditDetailsUserOutputContainerTitle = styled(CreditDetailsUserOutputContainer)` ${({ theme }) => `
  background:none;
  height:auto;
  margin-bottom: -${theme.padding[2]};
`}`;

export function CreditDetailsOutput({ label, value }: {label: string, value: any}) {
  return (
    <>
      {value != null && (
        <CreditDetailsOutputContainer>
          <CreditDetailsOutputContainerLabel>{label}</CreditDetailsOutputContainerLabel>
          <CreditDetailsOutputContainerValue>{value}</CreditDetailsOutputContainerValue>
        </CreditDetailsOutputContainer>
      )}
    </>
  );
}

export const TableSelectStylesHighlighted = css`${({ theme }) => `
  background:${theme.colours.secondary[5]} !important;
`}`;

export const CreditDivider = styled.div` ${({ theme }) => `
  height:${theme.borderWidth[2]};
  background:${theme.colours.neutral[8]};
  margin-left: ${theme.padding[9]};
  margin-right: ${theme.padding[9]};
`}`;

export const CreditDetailsRowHighlight = styled(CreditDetailsRow)` ${({ theme }) => `
  width: calc(100% - ${theme.padding[7]} * 2);
`}`;

export const ManualPaymentHistoryContainer = styled.div`${({ theme }) => `
  position: relative;
  background: ${theme.colours.neutral[9]};
  padding: ${theme.padding[5]};
  margin: 0 ${theme.fontSize[10]};

  ${CreditDetailsRow} {
    width: 100%;
  }

  ${EquifaxAccordionHeaderShadow} {
    background: linear-gradient(180deg, ${theme.colours.neutral[7]} 0%, ${theme.colours.neutral[9]} 100%);
  }

  ${CreditDivider} {
    background: ${theme.colours.neutral[7]};
    margin-left: 0;
    margin-right: 0;
  }
`}`;
